module.exports = __webpack_public_path__ + "static/fipcbluefloral4-7f3db49877f22d9481f0c9dd5f206d6b.jpeg";